import { REDUX } from 'constants/'
import { takeEvery, call, put } from 'redux-saga/effects'
import { appSelect , axiosSagas} from 'helper/sagas'
import { RootReducerState, Message } from 'types/global'
import {
    LocationReducer,
    LocationSectorStatus,
    LocationSectorStatusVariables,
    ResultUpdateLocationSector
} from 'types/location'
import { ROUTES_NAMES } from 'constants/servicenow.routes'

/**
 * Função 'worker' para atualizar status de uma LocationSector
 */
export function* updateLocationStatusCache() {
    const locationSelector: LocationReducer = yield* appSelect(
        (state: RootReducerState) => state.locationReducers
    )
    let locationSectorStatusVariables: LocationSectorStatusVariables = {
        u_sector:
            locationSelector.locationSector.x_rdsls_notificabe_sectors.value
    }
    let locationSectorStatus: LocationSectorStatus = {
        sysparm_quantity: 1,
        variables: locationSectorStatusVariables
    }
    if (locationSelector.locationSector.u_active.value === 'true')
        locationSectorStatus.variables.u_active_locations =
            locationSelector.locationSector.x_rdsls_notificabe_locations.value
    else if (locationSelector.locationSector.u_active.value === 'false')
        locationSectorStatus.variables.u_inactive_locations =
            locationSelector.locationSector.x_rdsls_notificabe_locations.value

    let newLocationSector = {
        ...locationSelector.locationSector,
        isLoading: false
    }

    try {
        const response:ResultUpdateLocationSector = yield call(axiosSagas.post, locationSectorStatus, 
            `${ROUTES_NAMES.location.post.update_sector_location_status}`)
    
        yield put({ type: REDUX.reducers.LAST_RETURN_UPDATE_LOCATION_SECTOR, payload: response.result})
        yield put({
            type: REDUX.reducers.MESSAGE_SECTOR,
            payload: { visible: true, 
                status: 1, 
                text: `Unidade ${locationSelector.locationSector.x_rdsls_notificabe_locations.display_value} 
                ${locationSelector.locationSector.u_active.value === 'true' ? 'ativada': 'inativada'} com sucesso` } as Message
        })
        
      } catch (e: any) {

        yield put({
            type: REDUX.reducers.MESSAGE_SECTOR,
            payload: { visible: true, 
                status: 2, 
                text: `Ocorreu um erro ao atualizar o status da unidade` } as Message
        })
      } finally{

        yield put({
            type: REDUX.reducers.END_UPDATE_LOCATION_SECTOR_LIST,
            payload: newLocationSector
        })

      }
}
/**
 * Função 'watcher' onde se manipulam os efeitos de cada 'worker'
 */
export function* LocationSagas() {
    yield takeEvery(
        REDUX.reducers.INIT_UPDATE_LOCATION_SECTOR_LIST,
        updateLocationStatusCache
    )
}
